__webpack_require__.p = "/chemical-manage/";